import React from 'react';
import { ReactEditorView } from './ReactEditorViewInternal';
import { injectIntl } from 'react-intl-next';
export function ReactEditorViewEditor(props) {
  return /*#__PURE__*/React.createElement(ReactEditorView, props);
}
export default injectIntl(ReactEditorViewEditor);